import { Component, OnInit, ElementRef } from '@angular/core';
import {AhmService} from "../../services/ahm.service";

@Component({
  selector: 'app-dynamic-content',
  templateUrl: './dynamic-content.component.html',
  styleUrls: ['./dynamic-content.component.css']
})
export class DynamicContentComponent implements OnInit {

  // dynamicContent = 'content works';
  viewContent = '';
  //sliderVisibility = 'visible';
  slider = 100;
  sliderVisibility = 'visible';
  //divElement;
  sliderHidden = true;
    formatLabel: any;

  constructor(private element: ElementRef) { }

  ngOnInit() {
    AhmService.prototype.setDynamicComponentLink(this);
  }

  psy(){
    alert(1);
  }

  sliderValueChanged() {
    // console.log('slider', this.slider);
    // this.sliderHidden = true;
  }

}
